export const DEFAULT_CASE_NAME = 'No Case Name Provided';
